import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("text", {
      fill: "#F3F9FF",
      "fill-rule": "evenodd",
      "font-family": "AppleColorEmoji, Apple Color Emoji",
      "font-size": "20",
      transform: "translate(-1 -2)"
    }, [
      _createElementVNode("tspan", {
        x: ".115",
        y: "21"
      }, "😵")
    ], -1)
  ])))
}
export default { render: render }